export default __webpack_public_path__ + "static/media/Homepage slide 2.17c49a9c.jpg";